import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["Component", "name", "selectedValue", "onChange", "children", "size", "clsPrefix", "className", "focusvalue", "disabled", "antd"];

var _dec, _class;

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import { get } from "lodash-es";
var propTypes = {
  name: PropTypes.string,

  /**
   * 默认选中的值
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
   * 选中的值
   */
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
   * 选中的值,作用与selectedValue一致，添加value属性是为了配合form表单校验初始化等一起使用
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
  * 暴露给用户，且与子Radio通信的方法
  */
  onChange: PropTypes.func,

  /**
    * radio 大小
    */
  size: PropTypes.oneOf(['lg', 'sm', 'small', 'large', 'default']),
  // 是否兼容ant design模式
  antd: PropTypes.bool,
  children: PropTypes.node.isRequired,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  disabled: PropTypes.bool
};
var defaultProps = {
  Component: 'div',
  clsPrefix: 'u-radio-group',
  defaultValue: '',
  antd: false
};
/**
 * 与子Radio通信
 */

var childContextTypes = {
  radioGroup: PropTypes.object
};
var RadioGroup = (_dec = WebUI({
  name: "radio-group",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup(props, context) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "getValues", function () {
      var array = [];
      var children = _this.props.children;

      if (!children || Array.isArray(children) && children.length === 0) {
        console.error('RadioGroup must have child nodes');
        return array;
      }

      if (!Array.isArray(children)) {
        // 如果只有一个元素，不是数组，则放到数组中
        children = [children];
      }

      children = children.map(function (child) {
        if (child) return child;
        return {
          props: {
            value: ''
          }
        };
      });

      if (children.length > 1) {
        children.map(function (item) {
          array.push(item.props.value);
        });
      } else if (children.length === 1) {
        array.push(children[0].props.value);
      } else {
        array.push(children.props.value);
      }

      return array;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          antd = _this$props.antd;
      var val = value;

      if (antd) {
        if (value.isBool) {
          val = value.target.value === 'true';
        }
      }

      if (!('selectedValue' in _this.props)) {
        _this.setState({
          selectedValue: val
        });
      }

      onChange && onChange(value);
    });

    var initValue = 'value' in props ? props.value : 'selectedValue' in props ? props.selectedValue : props.defaultValue;
    _this.state = {
      focusvalue: '',
      selectedValue: initValue
    };
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var array = this.getValues();

      if (array.indexOf(this.props.selectedValue) == -1) {
        this.setState({
          focusvalue: array[0]
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var array = this.getValues();

      if (array.indexOf(this.props.selectedValue) == -1 || array.indexOf(this.props.value) == -1) {
        this.setState({
          focusvalue: array[0]
        });
      } else {
        this.setState({
          focusvalue: ''
        });
      }

      if ('selectedValue' in nextProps || 'value' in nextProps) {
        this.setState({
          selectedValue: nextProps.selectedValue !== undefined ? nextProps.selectedValue : nextProps.value
        });
      }
    }
  }, {
    key: "getChildContext",
    value:
    /**
      * 一旦外层change方法触发本身props发生改变，则调用getChildContext更新与子Radio的通信信息（radioGroup）
      */
    function getChildContext() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          size = _this$props2.size;
      var selectedValue = this.state.selectedValue;
      var onChange = this.handleChange;
      return {
        radioGroup: {
          name: name,
          selectedValue: selectedValue,
          onChange: onChange,
          size: size,
          focusvalue: this.state.focusvalue
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          Component = _this$props3.Component,
          name = _this$props3.name,
          selectedValue = _this$props3.selectedValue,
          onChange = _this$props3.onChange,
          children = _this$props3.children,
          size = _this$props3.size,
          clsPrefix = _this$props3.clsPrefix,
          className = _this$props3.className,
          focusvalue = _this$props3.focusvalue,
          disabled = _this$props3.disabled,
          antd = _this$props3.antd,
          others = _objectWithoutProperties(_this$props3, _excluded);

      return /*#__PURE__*/React.createElement(Component, _extends({
        className: classnames(clsPrefix, className)
      }, others, {
        focusvalue: this.state.focusvalue
      }), React.Children.map(children, function (child) {
        if (!child) return null;
        return /*#__PURE__*/React.cloneElement(child, {
          disabled: get(child, "props.disabled") || disabled,
          antd: antd
        });
      }));
    }
  }]);

  return RadioGroup;
}(React.Component)) || _class);
RadioGroup.childContextTypes = childContextTypes;
RadioGroup.propTypes = propTypes;
export default RadioGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-radio/src/RadioGroup.js